module.exports = "/build/web/svg/copy.f93240d2efdaee81bcd34074b6addad4.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/copy.svg
// module id = 151
// module chunks = 24